import { css, unsafeCSS } from 'lit';
import { sbkCoreBreakpointLg } from '@/tokens/variables.js'

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const inputStyles = css`
    :host {
        --input__color: var(--_input__color, var(--sbkInputFgColorOnLightDefault));
        --input__color--disabled: var(--_input__color--disabled, var(--sbkInputFgColorOnLightDisabled));
        --input__color--error: var(--_input__color--error, var(--sbkInputFgColorOnLightError));

        --input__bg: var(--_input__bg, var(--sbkInputBgColorOnLightEnabled));
        --input__bg--active: var(--_input__bg--active, var(--sbkInputBgColorOnLightActive));
        --input__bg--hover: var(--_input__bg--hover, var(--sbkInputBgColorOnLightHover));
        --input__bg--focus: var(--_input__bg--focus, var(--sbkInputBgColorOnLightFocus));
        --input__bg--disabled: var(--_input__bg--disabled, var(--sbkInputBgColorOnLightDisabled));
        --input__bg--error: var(--_input__bg--error, var(--sbkInputBgColorOnLightError));

        --input__border: var(--_input__border, var(--sbkInputBorderOnLightEnabled));
        --input__border--active: var(--_input__border--active, var(--sbkInputBorderOnLightActive));
        --input__border--disabled: var(--_input__border--disabled, var(--sbkInputBorderOnLightDisabled));
        --input__border--error: var(--_input__border--error, var(--sbkInputBorderOnLightError));
        --input__border--focus: var(--_input__border--focus, var(--sbkInputBorderOnLightFocus));
        --input__border--hover: var(--_input__border--hover, var(--sbkInputBorderOnLightHover));
        --input__border--readonly: var(--_input__border--readonly, var(--sbkInputBorderOnLightDisabled));
    }

    .input__wrapper {
        margin-bottom: var(--sbkCoreSpacingMd);

        .label__wrapper + sbk-annotation {
            margin-top: calc(var(--sbkInput3xs) * -1);
            margin-bottom: var(--sbkInput3xs);
        }
    }

    .input__wrapper--error {
        .input {
            background-color: var(--input__bg--error);
            border: var(--input__border--error);
            color: var(--input__color--error);
        }
    }

    .input {
        background-color: var(--input__bg);
        border-radius: var(--sbkInputBorderRadiusDefault);
        border: var(--input__border);
        color: var(--input__color);
        outline: transparent;
        outline-offset: var(--sbkInputBorderGapFocus);
        font: var(--sbkInputSmallTextSm);
        padding: var(--sbkInput2xs);
        width: 100%;

        &[type="search"]::-webkit-search-decoration,
        &[type="search"]::-webkit-search-cancel-button,
        &[type="search"]::-webkit-search-results-button,
        &[type="search"]::-webkit-search-results-decoration {
            appearance: none;
        }

        &:not(&[readonly]):active {
            background-color: var(--input__bg--active);
            border: var(--input__border--active);
        }

        &:not(&[readonly]):focus {
            background-color: var(--input__bg--focus);
            outline: var(--input__border--focus);
        }

        @media (hover: hover) and (pointer: fine) {
            &:not(&[readonly]):hover:not(:focus) {
                background-color: var(--input__bg--hover);
                border: var(--input__border--hover);
            }
        }


        &[disabled] {
            background-color: var(--input__bg--disabled);
            border: var(--input__border--disabled);
            color: var(--input__color--disabled);
        }

        &[readonly] {
            background-color: initial;
            border: none;
            padding: 0;
            border-radius: 0;
        }

        &::placeholder {
            color: var(--input__color--disabled);
        }
    }

    .input--large {
        font: var(--sbkInputSmallTextSm);

        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkInputLargeTextLg);
            padding: var(--sbkInputXs);
        }
    }

    .input-container {
        position: relative;
    }

    .eye-icon-button {
        position: absolute;
        right: var(--sbkInput2xs);
        top: calc(50% - var(--sbkRoundButtonSizingMaxHeightSmallIconOnly) / 2);
        background-color: transparent;
        color: var(--input__color);
        outline: 2px solid transparent;
        outline-offset: var(--sbkButtonBorderGapFocus);
        border-radius: var(--sbkButtonBorderRadiusDefault);
        border: none;
        cursor: pointer;
        text-decoration: none;
        fill: currentColor;
        z-index: 3;

        .input__wrapper--error & {
            color: var(--input__color--error);
        }

        @media all and (min-width: ${breakpointLg}) {
            top: calc(50% - var(--sbkInputXs));
        }
    }

    input[type=password]::-ms-reveal,
    input[type=password]::-ms-clear {
        display: none;
    }

    input[type=password]::-webkit-contacts-auto-fill-button,
    input[type=password]::-webkit-credentials-auto-fill-button {
        visibility: hidden;
        display: none !important;
        pointer-events: none;
        height: 0;
        width: 0;
        margin: 0;
    }

    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
      -moz-appearance: textfield;
    }
`;
